import { render } from "./CartHeaderSummary.vue?vue&type=template&id=d3c8f1aa&scoped=true"
import script from "./CartHeaderSummary.vue?vue&type=script&lang=js"
export * from "./CartHeaderSummary.vue?vue&type=script&lang=js"

import "./CartHeaderSummary.vue?vue&type=style&index=0&id=d3c8f1aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c8f1aa"]])

export default __exports__